import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Admin ha accesso completo
  if (user?.role === 'admin') {
    return children;
  }

  // Amministratore ha accesso a tutto tranne le pagine riservate solo agli admin (es. Utenti)
  if (user?.role === 'amministratore' && requiredRole !== 'admin') {
    return children;
  }

  if (requiredRole && user?.role !== requiredRole) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;